module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('strong', [_c('big', [_vm._v("300")]), _c('br'), _vm._v("15-Minute"), _c('br'), _vm._v("Low-Carb Recipes")], 1)]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("DELICIOUS MEALS THAT MAKE IT EASY TO LIVE YOUR LOW-CARB LIFESTYLE AND NEVER LOOK BACK")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "author"
  }, [_c('strong', [_vm._v("Dana Carpender")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("Author of "), _c('em', [_vm._v("1001 LOW-CARB RECIPES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "images1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pub.jpg",
      "width": "50%"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47714b11","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm02.vue
// module id = 57
// module chunks = 0